import React from 'react';
import clazz from 'classnames';
import styles from './index.module.less';
// import placeholderImg from '@/assets/placeholder.png';
import placeholderImg from '@/assets/wow1.svg';
export default function Placeholder(props) {
    const { className, style = {}, text, imgUrl = placeholderImg, children, } = props;
    return (<div className={clazz(styles.placeholder, className)} style={style}>
      <img src={imgUrl} alt="placeholder"/>
      <p className={styles.text}>{text}</p>
      {children}
    </div>);
}
